import { makeAutoObservable } from "mobx";
import { SheetType, SheetProps } from "@/types/sheet";

export class SheetStore {
	type: SheetType | null = null;
	props: SheetProps[SheetType] | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	open<T extends SheetType>(type: T, props: SheetProps[T]) {
		this.type = type;
		this.props = props;
	}

	close() {
		this.type = null;
		this.props = null;
	}
}
